/**
 * IVA (VAT) helpers for facturas.
 *
 * `sales_request.price_with_iva` is a GENERATED column (`round(total_amount * 1.19, 0)`) that ALWAYS
 * adds 19% IVA. Facturas exentas (SII código 34) carry no IVA, so for them the gross (con IVA) amount
 * must equal the net (`total_amount`). Mirror the debt RPCs' rule everywhere gross is computed:
 *   gross = is_exento ? total_amount : price_with_iva
 */

export const IVA_RATE = 0.19;

/**
 * Gross (con IVA) from a net amount, respecting exempt status.
 * Exempt → net (rounded); otherwise net * 1.19 (rounded).
 */
export const grossFromNet = (
  net: number | null | undefined,
  isExento?: boolean | null
): number => {
  const n = Number(net) || 0;
  return Math.round(isExento ? n : n * (1 + IVA_RATE));
};

/**
 * Gross (con IVA) for a sales_request-like row that may carry `price_with_iva`, `total_amount`
 * and `is_exento`. For exempt rows the generated `price_with_iva` is wrong (it still adds 19%),
 * so we fall back to `total_amount`.
 */
export const resolveGross = (row: {
  price_with_iva?: number | null;
  total_amount?: number | null;
  is_exento?: boolean | null;
}): number => {
  if (row?.is_exento) return Math.round(Number(row.total_amount) || 0);
  const priceWithIva = Number(row?.price_with_iva);
  if (Number.isFinite(priceWithIva) && priceWithIva > 0) {
    return Math.round(priceWithIva);
  }
  return Math.round((Number(row?.total_amount) || 0) * (1 + IVA_RATE));
};
